import {v4 as uuid } from 'uuid';
 //Initialized  with sessionSettings, widgetSettings , widget, translation etc...
export default function initWithSession (isInAppRedirect = false) {
    this.env.page.sessionSettings = this.env.getSessionSettings();
    const session = this.env.page.sessionSettings;
    const schedulesStore = this.env.schedulesStore;
    const statesStore = this.env.uiStatesStore;
    const languageStore = this.env.languageStore

    console.log('initWithSession() Session:: ', session);
    this.widget = session.widget;
    this.widgetSettings = session.widgetSettings;
    this.oauthSessionId = session.oauthSessionId;
    this.location = session.location;
    this.optins = session.optins;
    console.log('initWithSession(): ', this.oauthSessionId);

    statesStore.selectedCalendar = session.selectedCalendar;
    schedulesStore.scheduleIds = session.scheduleIds; 
    schedulesStore.selectedSchedules = session.selectedSchedules;
    languageStore.setTranslations(session.translations);
    this.observed.widget = uuid();
    statesStore.observed.selectedCalendar = uuid();
    if (isInAppRedirect) {
        statesStore.initFieldValues();
    }
}
